import { render, staticRenderFns } from "./AdminOtherApp.vue?vue&type=template&id=22ad5278&"
import script from "./AdminOtherApp.vue?vue&type=script&lang=js&"
export * from "./AdminOtherApp.vue?vue&type=script&lang=js&"
import style0 from "@/assets/fonts/wf-stylesheet.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/admin_other_app.css?vue&type=style&index=1&lang=css&"
import style2 from "./AdminOtherApp.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports